export default __webpack_public_path__ + "static/media/personalDetailshelpHighlight.95474dd6.png";